<template>
  <default-layout>
    <event-navbar title="Community Contact" />
    <div class="container-fluid">
      <community-list></community-list>
    </div>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import CommunityList from '@/components/speaker/community-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'ContactListView',
  components: {
    CommunityList, EventNavbar, DefaultLayout
  },
}
</script>